import { memo, type ReactNode } from 'react';
import cn from 'classnames';
import { makeModifierClassname } from '../../lib/makeModifierClassname';
import styles from './TiltedBadge.module.css';

const modifier = makeModifierClassname(styles, 'badge');

export interface TiltedBadgeProps {
    children: ReactNode;

    variant?: 'brand' | 'primary';

    className?: string;
}

export const TiltedBadge = memo(function LoyaltyBadge({ children, variant = 'brand', className }: TiltedBadgeProps) {
    return <div className={cn(modifier.className, modifier('variant', variant), className)}>{children}</div>;
});
